import axios from 'axios'

export default {
    namespaced: true,
    state: {
        categories: []
    },
    mutations: {
        FETCH_CATEGORIES(state, categories) {
            state.categories = categories
        },
        ADD_CATEGORIES(state, category) {
            state.categories.push(category)
        },
        EDIT_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                Object.assign(state.categories[index], category)
            }
        },
        DEL_CATEGORIES(state, category) {
            const index = state.categories.findIndex(
                item => item.id === category.id
            )
            if (index !== -1) {
                state.categories.splice(index, 1)
            }
        }
    },
    actions: {
        fetch({commit, dispatch, state}, payload= {}) {
            console.log(payload)
            if (!state.categories.length || typeof payload.force !== 'undefined') {
                if (typeof payload.isPreload === 'undefined') {
                    commit('TOGGLE_PRELOADER', true, {root: true})
                }
                return axios.post(
                    '/api/beauty-manager/categories/list',
                    {beauty_salon_id: payload.beautyID}
                ).then(({data}) => {
                    commit('FETCH_CATEGORIES', data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                }).finally(() => {
                    if (typeof payload.isPreload === 'undefined') {
                        commit('TOGGLE_PRELOADER', false, {root: true})
                    }
                })
            }
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/beauty-manager/categories/add',
                    prepareData(data)
                ).then(({data}) => {
                    commit('ADD_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/beauty-manager/categories/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    commit('EDIT_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/beauty-manager/categories/dell/' + itemId
                ).then(({data}) => {
                    commit('DEL_CATEGORIES', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('beauty_salon_id', data.beauty_salon_id)

    return fd
}
